import { SeuConfigInputItem } from '@seu-types';

export type SeuGlobalValuesEmissionLimits = {
  presetId: string | null;
  inputs: SeuConfigInputItem[];
};

export const SEU_GLOBAL_VALUES_EMISSION_LIMITS_CONFIG_KEY = 'emissionLimit';
